type CopyStatus = 'idle' | 'copied' | 'failed';

interface CopySecretScreenProps {
  retrievalUrl: string;
  copyStatus: CopyStatus;
  onCopy: () => Promise<void>;
  onGenerateNew: () => void;
}

export function CopySecretScreen({ retrievalUrl, copyStatus, onCopy, onGenerateNew }: CopySecretScreenProps) {
  return (
    <div>
      <h1>Secret Generated</h1>
      <p className="subtitle">Copy the one-time URL and send it to the recipient.</p>

      <div className="result-box">
        <label>One-time retrieval URL</label>
        <div className="url-display">{retrievalUrl}</div>
        <button type="button" className="btn btn-secondary" onClick={onCopy}>
          {copyStatus === 'copied' ? 'Copied!' : copyStatus === 'failed' ? 'Copy failed' : 'Copy URL'}
        </button>
        <p className="muted">
          This link works exactly once. After the recipient opens it, the secret is permanently deleted.
        </p>
      </div>

      <p className="muted" style={{ marginTop: '1rem' }}>
        <button type="button" className="btn-link" onClick={onGenerateNew}>
          Generate a new secret
        </button>
      </p>
    </div>
  );
}
